// initial state
const state = {
  courses: {},
}

// getters
const getters = {
    
}

// actions
const actions = {
  
}

// mutations
const mutations = {
  setCourses (state, courses) {
    state.courses = courses
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}